import axios from 'axios'
import {AuthModel} from '../models/AuthModel'
import {UserModel} from '../models/UserModel'

const API_URL = process.env.REACT_APP_API_URL
const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID


export const SESSION_TOKEN_URL = `${API_URL}/session/token` 
export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/services/current/user` 
export const LOGIN_URL = `${API_URL}/oauth/token`
export const REGISTER_URL = `${API_URL}/auth/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/auth/forgot-password`

// Server should return AuthModel
export function login(email: string, password: string) {

  const data = {
    'client_id': CLIENT_ID,
    'grant_type': 'password',
    'client_secret': CLIENT_SECRET,
    'username': email,
    'password': password
  }
  var querystring = require('querystring');
  
  //console.log("getTokenBySession()", getTokenBySession(), getUserByToken())
  
  return getTokenBySession();
  //return getUserByToken();
  //return axios.post(LOGIN_URL, querystring.stringify(data));
}

// Server should return AuthModel
export function register(email: string, firstname: string, lastname: string, password: string) {
  return axios.post<AuthModel>(REGISTER_URL, {
    email,
    firstname,
    lastname,
    password,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {email})
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  // Check common redux folder => setupAxios
  
  
   // axios.defaults.withCredentials = true 
   
   const token = getTokenBySession();
  
    const headers = {
        "Content-Type" : "application/hal+json",
        "Accept" : "application/hal+json",
        "credentials":  'include'
    }
 
    return axios.get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {headers})
}


export function getTokenBySession() {
  // Authorization head should be fulfilled in interceptor.
  // Check common redux folder => setupAxios
    axios.defaults.withCredentials = true
    const headers = {
        "Content-Type" : "application/hal+json",
        "Accept" : "application/hal+json"
    }
 
  return axios.get<any>(SESSION_TOKEN_URL, {headers})
}
